import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Unsubscribable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SettingsSelectors } from '@rillion/store/settings';
import { formatNumber } from '@angular/common';

@Pipe({
  standalone: true,
  name: 'NumberMap',
})
export class MapNumberPipe implements OnDestroy, PipeTransform {
  private decimalSymbol = '.';
  private digitGroupingSymbol = ',';
  private subscription: Unsubscribable;

  constructor(private readonly store: Store) {
    this.subscription = this.store.select(SettingsSelectors.selectLanguage).subscribe((language) => {
      this.decimalSymbol = language?.decimalSymbol ?? '.';
      this.digitGroupingSymbol = language?.digitGroupingSymbol ?? ',';
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  transform(value: number, digitInfo = '1.2-2') {
    value = Math.round((value + Number.EPSILON) * 100) / 100;

    return formatNumber(value, 'en-GB', digitInfo).replace(',', this.digitGroupingSymbol).replace('.', this.decimalSymbol);
  }
}
